import { Star } from "lucide-react";

export const ReviewsTab = ({ items, onApprove, onDelete }) => {
  if (!items.length) return <p className="border border-white/10 p-10 text-center text-zinc-400" data-testid="reviews-admin-empty">No reviews yet.</p>;
  return (
    <div className="flex flex-col gap-3" data-testid="reviews-admin-list">
      {items.map((r) => (
        <div key={r.id} className="flex flex-col gap-3 border border-white/10 bg-[#111317] p-5 sm:flex-row sm:items-start sm:justify-between sm:gap-6" data-testid={`admin-review-${r.id}`}>
          <div>
            <div className="flex items-center gap-3">
              <span className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className={`h-3.5 w-3.5 ${i <= r.rating ? "fill-[#EDB89E] text-[#EDB89E]" : "text-zinc-600"}`} />
                ))}
              </span>
              <span className="font-bold text-zinc-50">{r.name}</span>
              {r.service && <span className="text-sm text-zinc-400">{r.service}</span>}
              {r.sample && <span className="rounded-full border border-white/15 px-2 py-0.5 font-mono-x text-[10px] uppercase tracking-widest text-zinc-500">sample</span>}
              <span className={`rounded-full px-2 py-0.5 font-mono-x text-[10px] uppercase tracking-widest ${r.approved ? "text-[var(--acid)]" : "text-amber-300"}`}>{r.approved ? "posted" : "pending"}</span>
            </div>
            <p className="mt-2 max-w-2xl text-sm text-zinc-300">&ldquo;{r.text}&rdquo;</p>
          </div>
          <div className="flex shrink-0 gap-2">
            <button onClick={() => onApprove(r, !r.approved)} data-testid={`admin-review-toggle-${r.id}`}
              className="rounded-full border border-white/15 px-4 py-2 text-sm font-semibold transition-colors hover:border-[var(--acid)] hover:text-[var(--acid)]">
              {r.approved ? "Unpost" : "Post it"}
            </button>
            <button onClick={() => onDelete(r)} data-testid={`admin-review-delete-${r.id}`}
              className="rounded-full px-4 py-2 text-sm font-semibold text-red-400 transition-colors hover:bg-red-500/10">Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};
